import React from "react";
import { Container, Row, Col, Ratio } from "react-bootstrap";

const VideoComponent = () => {
  return (
    <Container className="nfc-showcase py-5">
      <Row className="align-items-center">
        <Col md={6} className="mb-4 mb-md-0">
          <Ratio aspectRatio="16x9">
            <iframe
              src="https://www.youtube.com/embed/-75M_2UhTzQ"
              title="YouTube video 1"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullScreen
            ></iframe>
          </Ratio>
        </Col>

        <Col md={6} className="mb-4 mb-md-0">
          <Ratio aspectRatio="16x9">
            <iframe
              src="https://www.youtube.com/embed/ms2cUlgn3JA"
              title="YouTube video 2"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullScreen
            ></iframe>
          </Ratio>
        </Col>
      </Row>
    </Container>
  );
};

export default VideoComponent;
